module.exports = __webpack_public_path__ + "src/assets/img/customer-logos/affinity.2c736b815e0dee6f7db8cc7ad92e2871.png";